import { render, staticRenderFns } from "./HappeningModule.vue?vue&type=template&id=8c40f49a&"
import script from "./HappeningModule.vue?vue&type=script&lang=js&"
export * from "./HappeningModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports